﻿import { modalWindow } from './script.js';
function ShortlistOnPageLoad() {
    UpdateLocalStorageFromDb();
}
function UpdateLocalStorageFromDb() {
    window.sl.getShortlists().then(function (shortlists) {
        window.sl.shortlists = shortlists;
        SetShortlistedCottagesButton();
        updateListOfShortlists();
    });
}

function UserIsAuthenticated() {
    return $.cookie('auth') !== null;
}

function Token() {
    return $.cookie('auth');
}

function IsCodeInShortlists(code) {
    var found = 'false';
    if (UserIsAuthenticated()) {
        $(window.sl.shortlists).each(function (idx, sl) {
            $(sl.items).each(function (idx, i) {
                if (i.value === code.toString()) {
                    found = 'true';
                }
            });
        });
    } else {
        var shortlistString = $.cookie('Shortlist');
        var shortlistCottages = [];
        if (shortlistString !== null) {
            $.each(shortlistString.split(","), function (i, cottage) {
                if (cottage !== "") {
                    shortlistCottages.push(parseInt(cottage));
                }
            });
            if (shortlistCottages.indexOf(code) >= 0) {
                found = 'true';
            }
        }
    }
    return found;
}


export function SetShortlistedCottagesButton() {
    $('.shortlist-button').each(function () {
        $(this).attr('data-multi', UserIsAuthenticated());
        if (IsCodeInShortlists(parseInt($(this).attr('data-propertyid'), 10)) === 'true') {
            $(this).removeClass('add').addClass('remove').attr('title', 'Remove from shortlist');
        } else {
            $(this).removeClass('remove').addClass('add').attr('title', 'Add to shortlist');
        }
    });
}

function updateListOfShortlists() {
    if ($('.shortlist-links').length) {
        $('.shortlist-links').empty();
        $(window.sl.shortlists).each(function (idx, shortlist) {
            $('.shortlist-links').append('<p><a href="/shortlist?id=' + shortlist.id + '">' + shortlist.name + ' (' + shortlist.items.length + ')</a></p>');
        });
    }
}

$(function () {
    if (UserIsAuthenticated()) {
        window.sl = new Daffodil.Api('/api');
        ShortlistOnPageLoad();
    }

    SetShortlistedCottagesButton()

    $("a.clear-shortlist").live("click", function (e) {
        e.preventDefault();
        $.removeCookie("Shortlist");
        window.location.reload();
    });

    $("a.search-shortlist").live("click", function (e) {
        e.preventDefault();
        var thisCottageCode = parseInt($(this).data("propertyid"));
        var shortlistCottages = [];
        //get current shortlist string
        var shortlistString = $.cookie("Shortlist");

        if (UserIsAuthenticated()) {
            var data = '';
            var code = $(e.target).closest('a').attr('data-propertyid');
            var heart = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50.002 48.622" enable-background="new 0 0 50.002 48.622" xml:space="preserve">'
            heart += '<g><path d="M49.972,14.088c-0.256-4.303-2.193-8.327-5.18-10.761C42.199,1.213,38.77,0,35.381,0c-5.17,0-8.431,2.215-10.38,4.891C23.051,2.215,19.791,0,14.62,0c-3.389,0-6.818,1.213-9.41,3.327C2.222,5.762,0.285,9.785,0.029,14.088c-0.219,3.678,0.682,9.266,6.221,15c9.392,9.724,18.752,19.533,18.752,19.533s9.358-9.81,18.75-19.533C49.29,23.354,50.191,17.766,49.972,14.088z" /></g></svg>';
            data = '<div class="results-shortlist-list">';
            var active;
            if (window.sl.shortlists.length) {
                $(window.sl.shortlists).each(function (idx, sl) {
                    active = 'false';
                    $(sl.items).each(function (idx, item) {
                        if (parseInt(item.value) === thisCottageCode) {
                            active = 'true';
                        }
                    });
                    data += '<div class="results-shortlist-item add"> <p data-inlist="' + active + '" data-code="' + code + '" data-guid="' + sl.id + '"><span>' + sl.name + '</span>' + heart + '</p></div>';
                });
            } else {
                data += '<div class="results-shortlist-item add"> <p data-inlist="' + active + '" data-code="' + code + '"><span>Default</span>' + heart + '</p></div>';
            }
            data += '<div class="results-shortlist-item create"><p  data-code="' + code + '">Create new</p></div>';
            data += '</div>';
            $(this).qtip({
                content: data,
                overwrite: true, // Don't overwrite tooltips already bound
                position: {
                    viewport: $(window),
                    my: 'bottom center',
                    at: 'top center',
                    adjust: {
                        method: 'flip'
                    }
                },
                style: {
                    classes: 'qtip-light qtip-shadow shortlist-popup'
                },
                show: {
                    event: event.type, // Use the same event type as above
                    ready: true // Show immediately - important!
                },
                hide: 'unfocus',
                fixed: true
            });

        } else {
            //build array
            if (shortlistString !== null) { //if null then no cookie
                $.each(shortlistString.split(","), function (i, cottage) {
                    if (cottage !== "") {
                        shortlistCottages.push(parseInt(cottage));
                    }
                });
            }

            //add cottage
            if ($(this).hasClass("add")) {
                if (shortlistCottages.indexOf(thisCottageCode) === -1) {
                    shortlistCottages.push(thisCottageCode);
                }
            }
            //remove cottage
            if ($(this).hasClass("remove")) {
                if (shortlistCottages.indexOf(thisCottageCode) !== -1) {
                    shortlistCottages.splice(shortlistCottages.indexOf(thisCottageCode), 1);
                }
                if (window.location.href.indexOf('/shortlist', window.location.href.length - 10) != -1) { // on the shortlist page
                    //window.location.reload();
                    $(this).closest('.property-box').remove();
                    var currentCount = $('span.shortlist-count').text();
                    var newCount = currentCount - 1;
                    $('span.shortlist-count').text(newCount);
                    $('.search-result-info .count').text(newCount);

                }
            }

            //toggle classes
            if ($(this).hasClass("add")) {
                $(this).removeClass("add").addClass("remove").attr('title', 'Remove from shortlist');
            }
            else if ($(this).hasClass("remove")) {
                $(this).removeClass("remove").addClass("add").attr('title', 'Add to shortlist');
            }

            //rebuild cookie
            $.cookie('Shortlist', shortlistCottages.join(","), { expires: 30, path: '/' });

            //modify header shortlist link
            if (shortlistCottages.length === 0) {
                $("header nav .tab-shortlist").removeClass('active');
            } else {
                $("header nav .tab-shortlist").addClass('active');
            }
        }
    });

    $(".results-shortlist-item.add").live("click", function (e) {
        var shortlistId = $(e.target).closest('p').attr('data-guid');
        var thisSL;
        var inlist = $(e.target).closest('p').attr('data-inlist');
        var code = $(e.target).closest('p').attr('data-code');
        var matchedItem = '';

        if (typeof shortlistId !== 'undefined' && shortlistId !== null) {
            $(window.sl.shortlists).each(function (idx, sl) {
                if (sl.id === shortlistId) {
                    thisSL = sl;
                }
            });
            if (typeof thisSL !== 'undefined') {
                if (typeof thisSL.items !== 'undefined') {
                    $(thisSL.items).each(function (idx, i) {
                        if (i.value === code) {
                            matchedItem = i;
                        }
                    });
                }
            }
            if (inlist !== 'true') {
                if (typeof matchedItem === 'undefined' || matchedItem === '') {
                    window.sl.AddShortlistItem(shortlistId, code).then(function () {
                        ShortlistOnPageLoad();
                        $(e.target).closest('p').attr('data-inlist', 'true');
                        $('.shortlist-button[data-propertyid=' + code + ']').attr('data-active', 'true');
                    });
                }
            } else {
                window.sl.DeleteShortlistItem(shortlistId, matchedItem.id).then(function () {
                    if (IsCodeInShortlists(code) !== 'true') {
                        $('.shortlist-button[data-propertyid=' + code + ']').attr('data-active', 'false');
                    }
                    ShortlistOnPageLoad();
                    $(e.target).closest('p').attr('data-inlist', 'false');
                    if ($(document.getElementById('aspects_shortlist')).length) {
                        $('.shortlist-button[data-propertyid=' + code + ']').closest('.property-box-inner').remove();
                        var currentCount = $('.shortlist-count[data-listid="' + shortlistId + '"]').text();
                        var newCount = currentCount - 1;
                        $('.shortlist-count[data-listid="' + shortlistId + '"]').text(newCount);
                    }
                });
            }
        } else {
            window.sl.createShortlist('Default', 'false').then(function (CreatedShortlist) {
                thisSL = CreatedShortlist;
                window.sl.AddShortlistItem(thisSL.id, code).then(function () {
                    ShortlistOnPageLoad();
                    $(e.target).closest('p').attr('data-inlist', 'true');
                    $('.shortlist-button[data-propertyid=' + code + ']').attr('data-active', 'true');
                });
            });
        }
    });
    $('.shortlist-delete').live("click", function (e) {
        if (UserIsAuthenticated()) {
            var id = $(e.target).attr('data-guid');
            window.sl.deleteShortlist(id).then(function () {
                window.location = '/shortlist';
            });
        } else {
            $.cookie('Shortlist', null);
            window.location = '/shortlist';
           
        }
    });

    $('.shortlist__consent .close').live("click", function (e) {
        $('.shortlist__consent').hide();
    });

    $('.shortlist__consent .add-to-list').live("click", function (e) {
        var codes = $('.urlshortlistCodes').val().split(',');
        var selector = $('#ShortlistsConsent');
        var guid = $('#ShortlistsConsent option:selected').val();
        $(codes).each(function (idx, code) {
            window.sl.AddShortlistItem(guid, code);
        });

        window.location = '/shortlist?id=' + guid;
    });

    $('.shortlist__consent .create').live("click", function (e) {
        var url = window.location.href + '&SaveSharedShortlist=true';
        window.location = url;
    });

    $('.create-new-shortlist').live("click", function (e) {
        var name = $('#create-shortlist-name').val();
        if ($(e.target).attr('data-code') !== null) {
            var code = $(e.target).attr('data-code');
            window.sl.createShortlist(name, false).then(function (CreatedShortlist) {
                window.sl.AddShortlistItem(CreatedShortlist.id, code).then(function () {
                    UpdateLocalStorageFromDb();
                    $('#overlay-container').remove();
                    $('html').removeClass('ModalOn');
                });
            });
        } else {
            window.sl.createShortlist(name, false).then(function (CreatedShortlist) {
                UpdateLocalStorageFromDb();
            });
        }
        $('#overlay-container').remove();
    });

    $('.rename-shortlist').live("click", function (e) {
        var id = $(e.target).attr('data-guid');
        var name = $('#edit-shortlist-name').val();
        window.sl.updateShortlist(id, name, false).then(function () {
            window.location = '/shortlist?id=' + id;
        });
    });

    $('.shortlist-rename').live("click", function (e) {
        var id = $(e.target).attr('data-guid');
        var name = $(e.target).attr('data-name');
        var data = '<div id="request-container" class="clearfix"><h3>Update shortlist</h3><div><fieldset>'
        data += '<label class="required" for="edit-shortlist-name">Shortlist name</label>'
        data += '<input name="edit-shortlist-name" id="edit-shortlist-name" type="text" class="shortlist-name" value="' + name + '" /> </fieldset >'
        data += '<input type="submit" value="Update" class="button button-go rename-shortlist right" data-guid="' + id + '" /></div ></div >';
        modalWindow(data);
    });
    $('.shortlist-create, .results-shortlist-item.create').live("click", function (e) {
        var code = $(e.target).attr('data-code');
        var codeAttribute;
        if (code !== null) {
            codeAttribute = 'data-code="' + code + '"';
        }
        var data = '<div id="request-container" class="clearfix"><h3>Create a new shortlist</h3><div><fieldset>';
        data += '<label class="required" for="create-shortlist-name">Shortlist name</label>';
        data += '<input name="create-shortlist-name" id="create-shortlist-name" type="text" class="shortlist-name" /> </fieldset>';
        data += '<input type="submit" value="Create" ' + codeAttribute + ' class="button button-go create-new-shortlist right" /></div></div >';
        modalWindow(data);
    });

    $('.shortlist-share').live("click", function (e) {
        var siteURL = $('.shortlist-share').attr('data-siteurl');
        var url = siteURL + 'shortlist?addShortlist=';
        var name = $('#shortlist-name').text();
        $('.search-shortlist').each(function (idx, item) {
            url += $(item).attr('data-propertyid') + ',';
        });
        url += '&slname=' + encodeURI(name);
        $('#share-shortlist-name').val(url);
        var data = '<div id="request-container" class="clearfix share-shortlist" ><h3>Share your shortlist</h3><div><form action="post" ><fieldset>';
        data += '<label class="required" for="share-shortlist-name">share url</label><input name="emailShortlistURL" readonly id="shortlist-share-url" type="text" class="shortlist-name" value="' + url +'" /></fieldset>';
        data += '<input type="button" value="Copy" class="button share-shortlist right" onClick= "void(0)" style="cursor:pointer;"/><br style="clear:both;" /><div><p>Email to a friend</p>';
        data += '<fieldset class="email-fields"><input type="hidden" name="emailType" class="modal-share__email-type" value="SMShortlist"><input type="hidden" name="emailSubject" class="modal-share__email-subject" value="Shortlisted Holiday Cottages - Aspects Holidays">';
        data += '<input type="hidden" name="emailData" class="modal-share__email-data" value="">';
        data += '<input type="text" name="emailFrom" class="modal-share__email-from" placeholder="Your email address">';
        data += '<input type="text" name="emailTo" placeholder="Friends email address">';
        data += '<input type="button" value="Send" class="button right send-email" />';
        data += '<div id="emailSentMsg" style="display:none;"><p>Email has been sent</p></div>';
        data += '<br style="clear:both;" /></fieldset></div></form>';
        data += '</div></div>';
        modalWindow(data);        
    });
    $('input.send-email').live("click", function (e) {
        var values = [];
        $('.share-shortlist input').each(function (idx, element) {
            if (element.name !== undefined && element.name !== '') {
                values.push(encodeURIComponent(element.name) + '=' + encodeURIComponent(element.value));
            }
        });
        $('#emailSentMsg').css('display', '');
        $('#overlay-container').delay(500).fadeOut("slow", function () { $(this).remove();});
        //$('#overlay-container').remove();
        $('html').removeClass('ModalOn');
        data = values.join('&');
        $.ajax({
            type: "POST",
            url: '/ajax/shareShortlist.aspx',
            data: data
        });
    });

    $('input.share-shortlist').live("click", function (e) {
        e.preventDefault();
        var copytext = document.getElementById('shortlist-share-url');
        copytext.select();
        document.execCommand('copy');
        document.getElementById('shortlist-share-url').focus();
    });

    $('.shortlist-aside__select select').change(function (e) {
        var shortlistId = e.target.value;
        window.location = '/shortlist?id=' + shortlistId;
    });
});